// extracted by css-extract-rspack-plugin
export default {"wrapper":"src-modules-desktop-components-UtilityWindowWrapper-UtilityWindowWrapper-module__wrapper-L93GOi","content":"src-modules-desktop-components-UtilityWindowWrapper-UtilityWindowWrapper-module__content-fh7Fqd","header":"src-modules-desktop-components-UtilityWindowWrapper-UtilityWindowWrapper-module__header-F75yXD","title":"src-modules-desktop-components-UtilityWindowWrapper-UtilityWindowWrapper-module__title-kzVm1Y","main":"src-modules-desktop-components-UtilityWindowWrapper-UtilityWindowWrapper-module__main-tBcfgx"};
    if(module.hot) {
      (function() {
        var localsJsonString = "{\"wrapper\":\"src-modules-desktop-components-UtilityWindowWrapper-UtilityWindowWrapper-module__wrapper-L93GOi\",\"content\":\"src-modules-desktop-components-UtilityWindowWrapper-UtilityWindowWrapper-module__content-fh7Fqd\",\"header\":\"src-modules-desktop-components-UtilityWindowWrapper-UtilityWindowWrapper-module__header-F75yXD\",\"title\":\"src-modules-desktop-components-UtilityWindowWrapper-UtilityWindowWrapper-module__title-kzVm1Y\",\"main\":\"src-modules-desktop-components-UtilityWindowWrapper-UtilityWindowWrapper-module__main-tBcfgx\"}";
        // 1793873550546
        var cssReload = require("../../../../../node_modules/.pnpm/@rspack+core@1.5.8_@swc+helpers@0.5.17/node_modules/@rspack/core/dist/cssExtractHmr.js").cssReload(module.id, {});
        // only invalidate when locals change
        if (
          module.hot.data &&
          module.hot.data.value &&
          module.hot.data.value !== localsJsonString
        ) {
          module.hot.invalidate();
        } else {
          module.hot.accept();
        }
        module.hot.dispose(function(data) {
          data.value = localsJsonString;
          cssReload();
        });
      })();
    }
  